const SupplierTodoType = {
  SET_SUPPLIER_CONFIG_DATA: 'SET_SUPPLIER_CONFIG_DATA',
  SET_SUPPLIER_REQUESTS_TODOLIST: 'SET_SUPPLIER_REQUESTS_TODOLIST',
  SET_SUPPLIER_FILTER_SORT_DATA: 'SET_SUPPLIER_FILTER_SORT_DATA',
  SET_SUPPLIER_DETAIL_DATA: 'SET_SUPPLIER_DETAIL_DATA',
  GET_COMPONENT_TYPE: 'GET_COMPONENT_TYPE',
};

export default SupplierTodoType;
